import React from "react";

import { usePending } from "./hooks";

export const Pending = React.memo(() => {
  const { getPendingProps } = usePending();
  return (
    <div {...getPendingProps()}>
      <span>СЛЕДУЮЩАЯ ГОНКА</span>
      <span>ОТКРЫТ ПРИЕМ ПРОГНОЗОВ</span>
    </div>
  );
});

Pending.displayName = "Pending";
